<template>
  <v-row
    v-if="hasAnyPaymentDetails"
    id="financial"
    class="bt-1 bc-very-light-gray c-black mb-2 pt-1"
  >
    <v-col
      cols="12"
      lg="4"
      xl="3"
    >
      <div class="fw-600 fs-18">
        {{ $bct('Financial programs') }}
      </div>
    </v-col>

    <v-col
      class="c-black fs-16 fw-500 mxw-400 d-flex flex-column ga-2"
      cols="12"
      lg="8"
      xl="9"
    >
      <v-row
        v-if="provider.accepts_subsidy"
        class="fs-16 fw-400"
        dense
      >
        <v-col class="d-flex align-center">
          <v-icon
            class="va-text-bottom me-1 c-green fs-24"
            icon="check_circle"
          />

          <span class="fs-16 fw-400 fs-16">
            {{ $bct('This child care provider accepts financial aid') }}
          </span>
        </v-col>
      </v-row>

      <v-row
        v-if="provider.payment_subsidies_accepted.length > 0"
        dense
      >
        <v-col cols="1">
          <v-icon
            class="fs-24"
            color="#578052"
            icon="attach_money"
          />
        </v-col>

        <v-col cols="11">
          <div class="fs-16 fw-500 mb-1">
            {{ $bct(getLabelByProperty('payment_subsidies_accepted', 'Subsidies accepted')) }}
          </div>

          <div
            v-for="(paymentType, index) in provider.payment_subsidies_accepted"
            :key="index"
            class="fs-16 fw-400"
            data-testId="payment-subsidies"
          >
            {{ $bct(paymentType) }}
          </div>
        </v-col>
      </v-row>

      <v-row
        v-if="provider.payment_other_programs.length > 0"
        dense
      >
        <v-col cols="1">
          <img
            :src="$a.url('icons.headstart')"
            alt="Head Start icon"
            class="h-24"
          />
        </v-col>

        <v-col cols="11">
          <div class="fs-16 fw-500 mb-1">
            {{ $bct(getLabelByProperty('payment_other_programs', 'Other assistance programs')) }}
          </div>

          <div
            v-for="(program, index) in provider.payment_other_programs"
            v-text="program"
            :key="index"
            class="fs-16 fw-400"
            data-testId="payment-programs"
          />
        </v-col>
      </v-row>

      <v-row
        v-if="provider.payment_other_description"
        dense
      >
        <v-col cols="1">
          <v-icon
            class="fs-24"
            color="primary"
            icon="loyalty"
          />
        </v-col>

        <v-col cols="11">
          <div class="fs-16 fw-500 mb-1">
            {{
              $bct(getLabelByProperty('payment_other_description', 'Additional payment options'))
            }}
          </div>

          <div class="fs-16 fw-400">
            {{ $bct(provider.payment_other_description) }}
          </div>
        </v-col>
      </v-row>

      <v-row
        v-if="provider.payment_methods_accepted.length > 0"
        dense
      >
        <v-col cols="12">
          <div class="fs-16 fw-500 mb-2">
            {{ $bct(getLabelByProperty('payment_methods_accepted', 'Payment methods accepted')) }}
          </div>

          <div
            v-for="(method, index) in provider.payment_methods_accepted"
            :key="index"
            class="d-inline-block me-3"
            data-testId="payment-methods"
          >
            <v-icon
              class="me-1 fs-24 va-text-bottom"
              color="primary"
              icon="check_circle"
            />

            <span
              v-text="$bct(method)"
              class="fs-16 fw-400"
            />
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script setup>
import useSchematizedField from '@/shared/composables/useSchematizedField';

const $bct = inject('translator');

const props = defineProps({
  provider: {
    type: Object,
    default: null,
  },
});

const { getLabelByProperty } = useSchematizedField(
  ref(null),
  ref(null),
  ref(null),
  ref(null),
  computed(() => props.provider?.schema_id),
);

const hasAnyPaymentDetails = computed(() => {
  return (
    props.provider.payment_methods_accepted.length > 0 ||
    props.provider.payment_subsidies_accepted.length > 0 ||
    props.provider.payment_other_programs.length > 0 ||
    props.provider.payment_other_description ||
    props.provider.accepts_subsidy
  );
});
</script>
